
import { Vue, Component, Prop } from 'vue-property-decorator'

interface Question {
  answer: string;
}

@Component({
  name: 'QuestionPreview'
})

export default class QuestionPreview extends Vue {
  @Prop() title!: string
  @Prop() question!: Question
}
